import { createSelector } from 'reselect';
import get from 'lodash/get';
import drop from 'lodash/drop';

const defaults = {
    context: {},
    deviceType: {},
    featureFlags: {},
    preferences: {},
    messagesTexts: {},
    endpoints: {},
    reqHeaders: {},
    shouldRender: true,
};

// const getThresholdLimitForDeviceType = (preferences, deviceType) => {
//     const thresholdLimit = get(preferences, 'secondaryNavigationMenu.thresholdLimit', null);
//     let thresholdValue = 0;
//     if (thresholdLimit) {
//         if (deviceType.isMobile) {
//             thresholdValue = thresholdLimit.mobile;
//         } else if (deviceType.isTablet) {
//             thresholdValue = thresholdLimit.tablet;
//         } else {
//             thresholdValue = thresholdLimit.desktop;
//         }
//     }
//     return thresholdValue;
// };

export const selectContext = (state) => state.context || defaults.context;

const selectBagItemCount = (state) => state.bagItemCount || 0;

export const isPreview = createSelector([selectContext], (context) =>
    get(context, 'isPreview', false)
);

export const selectPreferences = createSelector([selectContext], (context) =>
    get(context, 'preferences', defaults.preferences)
);
export const selectMessagesTexts = createSelector([selectContext], (context) =>
    get(context, 'messagesTexts', defaults.messagesTexts)
);
export const selectReqHeaders = createSelector([selectContext], (context) =>
    get(context, 'headers', defaults.reqHeaders)
);

export const selectPreferencesMaxOrderQuantity = createSelector(
    [selectPreferences],
    (preferences) => get(preferences, 'maxOrderQuantity', defaults.maxOrderQuantity)
);

export const selectFeatureFlags = createSelector(
    [selectContext],
    (context) => context.featureFlags || defaults.featureFlags
);

export const selectDeviceType = createSelector(
    [selectContext],
    (context) => context.deviceType || defaults.deviceType
);

export const selectDebugFlag = createSelector([selectContext], (context) =>
    get(context, 'debug.debugFlag', false)
);

export const selectShouldRender = createSelector([selectContext], (context) =>
    get(context, 'shouldRender', defaults.shouldRender)
);

export const selectSizeBasedOnDeviceType = createSelector([selectDeviceType], (deviceType) => {
    if (deviceType.isMobile) {
        return 'small';
    }
    if (deviceType.isTablet) {
        return 'medium';
    }
    return 'large';
});

export const selectDeviceName = createSelector([selectDeviceType], (deviceType) => {
    if (deviceType.isMobile) {
        return 'mobile';
    }
    if (deviceType.isTablet) {
        return 'tablet';
    }
    return 'desktop';
});

export const hamburgerPreferencesSelector = createSelector([selectContext], (context) => {
    const hybridHamburgerFlagSelector = createSelector([selectContext], (ctx) =>
        get(ctx, 'featureFlags.enableHybridHamburger', false)
    );
    const enableHybridHamburger = hybridHamburgerFlagSelector({ context });

    return enableHybridHamburger
        ? get(context, 'preferences.hybridHamburger', null)
        : get(context, 'preferences.hamburger', null);
});

export const hamburgerPreferencesDeptSelector = createSelector([selectContext], (context) => {
    const hybridHamburgerFlagSelector = createSelector([selectContext], (ctx) =>
        get(ctx, 'featureFlags.enableHybridHamburger', false)
    );
    const enableHybridHamburger = hybridHamburgerFlagSelector({ context });

    return enableHybridHamburger
        ? get(context, 'preferences.hybridDeptsHamburger', {})
        : get(context, 'preferences.hamburger', {});
});

export const selectMoreSecondaryNavigationMenuList = createSelector(
    [selectPreferences],
    (preferences) => {
        let moreSecondaryMenuOptions = [];
        const menuDisplayThresholdValue = get(
            preferences,
            'secondaryNavigationMenu.thresholdLimit',
            0
        );
        const secondaryMenuList = get(preferences, 'secondaryNavigationMenu.menuList', []);
        moreSecondaryMenuOptions = menuDisplayThresholdValue
            ? drop(secondaryMenuList, menuDisplayThresholdValue)
            : [];
        return moreSecondaryMenuOptions;
    }
);

export const selectApplyingToEmptyCart = createSelector(
    [selectFeatureFlags, selectBagItemCount],
    (featureFlags, bagItemCount) => featureFlags.Coupon_AllowApplyEmptyCart && bagItemCount <= 0
);

export const selectInteractiveVizNavCacheMins = createSelector([selectPreferences], (preferences) =>
    get(preferences, 'interactiveVizNav.cacheMins', 30)
);
